module.exports = __webpack_public_path__ + "img/sort／web／Hypercasual@2x.6a810f80.png";